import { toastSuccess } from "../components/atoms/CustomToast";

export const handleCopyToClipboard = (value) => {
  navigator.clipboard.writeText(value);
  toastSuccess(`Berhasil disalin`)
}